{
  "welcome.title": "Вашему ребёнку есть что сказать",
  "welcome.body": "Ответьте на несколько коротких вопросов, и Тимо составит бесплатный персональный план, который поможет вашему ребёнку обрести свой голос. Это займёт около 90 секунд.",
  "welcome.cta": "Начать",
  "gender.question": "Ваш ребёнок мальчик или девочка?",
  "gender.opt.boy": "Мальчик",
  "gender.opt.girl": "Девочка",
  "age.question": "Сколько лет вашему ребёнку?",
  "age.sub": "Чтобы Тимо задавал вопросы, подходящие его возрасту.",
  "age.opt.under3": "До 3",
  "age.opt.3-4": "3-4",
  "age.opt.5-6": "5-6",
  "age.opt.7+": "7+",
  "name.question": "Как зовут вашего ребёнка?",
  "name.sub": "Или домашнее имя, чтобы Тимо обращался лично.",
  "name.placeholder": "Имя ребёнка",
  "words.question": "Сколько примерно слов может сказать {name}?",
  "words.sub": "Достаточно примерной оценки.",
  "words.opt.0": "0 слов",
  "words.opt.1-5": "1-5 слов",
  "words.opt.6-10": "6-10 слов",
  "words.opt.11-50": "11-50 слов",
  "words.opt.50+": "50+ слов",
  "words.opt.unsure": "Не знаю",
  "sentences.question": "Строит ли {name} длинные предложения (4-6 слов) в основном без грамматических ошибок?",
  "sentences.opt.yes": "Да",
  "sentences.opt.no": "Нет",
  "delay_fact.title": "Чем раньше начать, тем больше разница",
  "delay_fact.body": "Несколько минут в день с Тимо, и {name} ждёт их с нетерпением.",
  "delay_fact.cta": "Далее",
  "calc.title": "Готовим обзор: как общается {name}",
  "calc.arr.0": "Понимаем, что нужно вашему ребёнку...",
  "calc.arr.1": "Сравниваем с этапами развития...",
  "calc.arr.2": "Подбираем подходящие занятия...",
  "calc.arr.3": "Почти готово...",
  "calc.review.text": "Мой сын от нескольких слов перешёл к коротким предложениям. С Тимо ему самому хочется говорить.",
  "calc.review.author": "Раса, мама 4-летнего ребёнка",
  "score.title": "Как общается {name}",
  "score.arr.0": "Речь",
  "score.arr.1": "Понимание",
  "score.arr.2": "Диалог",
  "score.arr.3": "Уверенность",
  "score.arr.4": "Общение",
  "score.cta": "Составить план",
  "voice.question": "Выберите голос Тимо",
  "voice.sub": "Нажмите на карточку, чтобы услышать пример.",
  "email.title": "Создайте бесплатный аккаунт",
  "email.sub": "План сохранится, и вы сможете вернуться в любой момент.",
  "conversation.question": "Может ли {name} поддерживать разговор без особой помощи взрослого?",
  "conversation.opt.yes": "Да",
  "conversation.opt.no": "Нет",
  "questions.question": "Любит ли {name} задавать много вопросов, например «Почему идёт дождь?»",
  "questions.opt.yes": "Да",
  "questions.opt.no": "Нет",
  "find_words.question": "Бывает ли, что {name} не может подобрать слово в нужный момент?",
  "find_words.opt.yes": "Да",
  "find_words.opt.no": "Нет",
  "sounds.question": "Какие звуки {name} произносит чётко?",
  "sounds.sub": "Отметьте все подходящие. Так Тимо подберёт нужные упражнения.",
  "sounds.opt.p_b": "П, Б  (папа, банан)",
  "sounds.opt.m_n": "М, Н  (мама, нос)",
  "sounds.opt.t_d": "Т, Д  (тапки, дом)",
  "sounds.opt.k_g": "К, Г  (кот, гусь)",
  "sounds.opt.f_v": "Ф, В  (фонарь, вода)",
  "sounds.opt.s_z": "С, З  (солнце, зонт)",
  "sounds.opt.l": "Л  (лев)",
  "sounds.opt.r": "Р  (рыба)",
  "sounds.opt.sh_ch": "Ш, Ч  (шуба, чашка)",
  "therapist.question": "Обращались ли вы когда-нибудь к логопеду?",
  "therapist.opt.yes": "Да",
  "therapist.opt.no": "Нет",
  "diagnosis.question": "Есть ли у ребёнка диагноз?",
  "diagnosis.sub": "Это остаётся конфиденциальным и только помогает Тимо настроить план.",
  "diagnosis.opt.autism": "Аутизм / РАС",
  "diagnosis.opt.speech_delay": "Задержка речевого развития",
  "diagnosis.opt.adhd": "СДВГ",
  "diagnosis.opt.none": "Нет диагноза",
  "diagnosis.opt.prefer_not": "Предпочитаю не отвечать",
  "social.question": "Тяжело ли ребёнку в группе или в общении с другими?",
  "social.opt.yes": "Да",
  "social.opt.no": "Нет",
  "goals.question": "Чем Тимо может помочь больше всего?",
  "goals.sub": "Выберите до 3. Это определяет весь план.",
  "goals.opt.confidence": "Увереннее говорить",
  "goals.opt.conversations": "Тренировать повседневные разговоры",
  "goals.opt.social": "Справляться с трудными социальными моментами",
  "goals.opt.feelings": "Выражать чувства здоровым способом",
  "goals.opt.calm": "Сохранять спокойствие, когда всего слишком много",
  "goals.opt.school": "Подготовиться к школе",
  "topics.question": "Выберите любимые темы",
  "topics.sub": "Тимо вплетёт их в занятия.",
  "topics.opt.animals": "Животные",
  "topics.opt.space": "Космос",
  "topics.opt.vehicles": "Транспорт",
  "topics.opt.music": "Музыка",
  "topics.opt.nature": "Природа",
  "topics.opt.food": "Еда",
  "experts.title": "Создано со специалистами, подстроено под вашего ребёнка",
  "experts.body": "Timo Helps опирается на методику речевого развития и общения при аутизме, а затем подстраивается под ваши ответы. Никогда не одинаково для всех.",
  "experts.quote.text": "Более 10 000 семей используют Timo Helps, чтобы их ребёнок обрёл свой голос.",
  "experts.quote.author": "Средняя оценка 4,8",
  "experts.cta": "Посмотреть план",
  "learn_style.question": "Как {name} больше всего любит учиться?",
  "learn_style.opt.hands_on": "Занимаясь практическими делами",
  "learn_style.opt.stories": "Слушая истории",
  "learn_style.opt.video": "Просматривая видео",
  "learn_style.opt.games": "Играя в игры",
  "strengths.question": "В чём сильные стороны ребёнка?",
  "strengths.sub": "Отметьте всё, что подходит.",
  "strengths.opt.creative": "Творчество",
  "strengths.opt.curious": "Любознательность",
  "strengths.opt.caring": "Забота",
  "strengths.opt.determined": "Упорство",
  "strengths.opt.funny": "Чувство юмора",
  "challenge.question": "Что сейчас даётся ребёнку труднее всего?",
  "challenge.opt.frustrated": "Быстро расстраивается",
  "challenge.opt.distracted": "Легко отвлекается",
  "challenge.opt.shy": "Стесняется или тревожится с людьми",
  "challenge.opt.overwhelmed": "Быстро перегружается",
  "daily_time.question": "Сколько времени в день реально уделять?",
  "daily_time.sub": "Даже несколько минут быстро складываются.",
  "daily_time.opt.5": "Небольшой старт",
  "daily_time.hint.5": "5 мин в день",
  "daily_time.opt.10": "В самый раз",
  "daily_time.hint.10": "10 мин в день",
  "daily_time.opt.20": "На полную",
  "daily_time.hint.20": "20 мин в день",
  "when.question": "Когда {name} будет заниматься?",
  "when.opt.morning": "Утром",
  "when.hint.morning": "Спокойное начало",
  "when.opt.afternoon": "Днём",
  "when.hint.afternoon": "Заряд среди дня",
  "when.opt.evening": "Вечером",
  "when.hint.evening": "Спокойно перед сном",
  "who_uses.question": "Кто будет пользоваться Timo Helps вместе с ребёнком?",
  "who_uses.opt.mom": "Мама",
  "who_uses.opt.dad": "Папа",
  "who_uses.opt.grandparent": "Бабушка или дедушка",
  "who_uses.opt.specialist": "Специалист или учитель",
  "who_uses.opt.themselves": "Ребёнок сам",
  "timeline.question": "Как скоро вы хотите увидеть прогресс?",
  "timeline.opt.weeks": "За несколько недель",
  "timeline.opt.1-2m": "За 1-2 месяца",
  "timeline.opt.no_rush": "Без жёстких сроков",
  "main_goal.question": "Какая у вас сейчас главная цель?",
  "main_goal.opt.catch_up": "Помочь ребёнку наверстать",
  "main_goal.opt.on_track": "Сохранить темп прогресса",
  "main_goal.opt.confidence": "Укрепить уверенность в себе",
  "main_goal.opt.other": "Что-то другое",
  "profile_done.title": "Полный план готов",
  "profile_done.body": "У Тимо есть всё нужное. Начнём заниматься вместе.",
  "profile_done.cta": "Начать занятия"
}
